<app-base-dialog [noGap]="true" [noPadding]="true" [topBarTemplate]="topBar" sizeClass="size-22">
	<ng-template #topBar>
		<app-dialog-header class="secondary" title="Eerdere chats" />
	</ng-template>
	<div class="chat-history-container">
		@for (group of groupedChats(); track group.header) {
			<div class="chat-group">
				<div class="group-header">{{ group.header }}</div>
				@for (chat of group.chats; track chat.id) {
					<div class="chat-item">
						@if (editingChat() !== chat) {
							<div class="chat-subject" (click)="onChatSelected(chat)" [appTooltip]="getTooltip(chat)">{{ chat.onderwerp }}</div>
							@if (!inspect()) {
								<app-meatball-menu>
									<app-meatball-menu-item icon="edit" (click)="editingChat.set(chat)">Bewerken</app-meatball-menu-item>
									<app-meatball-menu-item icon="delete" (click)="deleteChat(chat)">Verwijderen</app-meatball-menu-item>
								</app-meatball-menu>
							}
						} @else {
							<app-immediate-input class="chat-onderwerp" [init]="chat.onderwerp" (done)="updateChat(chat, $event)" />
						}
					</div>
				}
			</div>
		}
	</div>
</app-base-dialog>

<ng-template #confirmDeleteDialog let-chat>
	<app-confirm-dialog caption="Chat verwijderen" action="Verwijderen">
		Je staat op het punt om de conversatie <b>{{ chat.onderwerp }}</b> te verwijderen. Weet je het zeker?
	</app-confirm-dialog>
</ng-template>
